<script lang="ts">
  import { t } from '$lib/i18n';
  import { session } from '$lib/state/session.svelte';
  import { boardIsMyTask, boardSourceLabel } from '$lib/utils/board';
  import type { BoardCard } from '$lib/types';

  const { card }: { card: BoardCard } = $props();

  const isDirected = $derived(Boolean(card.source?.trim()));
  const isMine = $derived(boardIsMyTask(card, session.me));
  const label = $derived(
    boardSourceLabel(card, t('board.source.commandCentre'), t('board.source.chiefOfStaff'))
  );
</script>

{#if isMine || (isDirected && label)}
  <span
    class="mt-1.5 inline-flex items-center rounded-full bg-toyama-teal/10 px-1.5 py-px text-[10.5px] font-medium text-toyama-teal"
  >
    {isMine ? t('board.myTask') : t('board.fromLabel', { label })}
  </span>
{/if}
